import { Link } from 'react-router-dom';
import { usePublicConfig } from '../PublicShell';
import { LegalLayout, Section, Table } from './LegalLayout';

export default function Cookies() {
  const c = usePublicConfig();
  const product = c.company.product;

  return (
    <LegalLayout
      title="Cookies"
      updated="11 September 2026"
      intro={
        <>
          {product} uses no tracking cookies, no analytics and no advertising. There is no
          consent banner because there is nothing to consent to. The one third-party embed
          anywhere in the product is the live chat on our own Help page, which loads only if
          you open it.
        </>
      }
    >
      <Section title="What we store on your device">
        <p>
          Strictly necessary storage only. Under the Privacy and Electronic Communications
          Regulations, storage that is essential to provide a service the user has asked for
          does not require consent — which is the whole of what we use.
        </p>
        <Table
          head={['Name', 'Type', 'Purpose', 'Lifetime']}
          rows={[
            ['provia.token', 'Local storage', 'Keeps you signed in between page loads. Without it you would re-enter your password on every screen.', 'Until you sign out, or the session expires'],
            ['provia.theme', 'Local storage', 'Remembers whether you chose the light or dark theme.', 'Until you clear it'],
          ]}
        />
        <p>
          Both are local storage rather than cookies, so they are never sent to a server with a
          request. They stay in your browser.
        </p>
      </Section>

      <Section title="What we do not use">
        <Table
          head={['', '']}
          rows={[
            ['Analytics', 'None. We do not measure how you use the app.'],
            ['Advertising or tracking', 'None, on any page.'],
            ['Third-party embeds', 'One, and only if you open it: the live chat on the Help page inside the app. Nothing from it loads on any other screen.'],
            ['Session recording or heatmaps', 'None.'],
          ]}
        />
      </Section>

      <Section title="Live chat on the Help page">
        <p>
          Where live chat is switched on, opening the Help page inside {product} loads a widget
          from tawk.to, which sets its own storage so a conversation survives a page reload.
          It is loaded on that page and nowhere else — not on the dashboard, not on your
          tenants&rsquo; records, and not on the tenant portal — so no third-party script runs
          while anybody&rsquo;s personal data is on screen.
        </p>
        <p>
          If you never open the Help page, nothing from tawk.to is ever requested. What you
          type into the chat goes to them as part of answering you; the page behind it does
          not.
        </p>
      </Section>

      <Section title="Clearing it">
        <p>
          Signing out removes the session token. Clearing your browser&rsquo;s site data for this
          domain removes both items; you will then be signed out and the theme will return to its
          default.
        </p>
        <p>
          Blocking local storage entirely will stop you staying signed in, but nothing else
          breaks.
        </p>
      </Section>

      <Section title="More">
        <p>
          How we handle personal data is in the <Link to="/privacy">privacy policy</Link>.
          Questions: <a href={`mailto:${c.contact.privacy}`}>{c.contact.privacy}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
